<template lang="pug">
  el-card.box-processo(shadow="hover")
    h1 Mover por Remessa
    div.containerTodo
      div.container
        label Caixa atual:
          el-input.input(placeholder="Digite a caixa atual" type="text" v-model="caixaAtual")
        label Caixa destino:
          el-input.input(placeholder="Digite a caixa destino" type="text" v-model="caixaDestino")
        label.input Saidas esperadas caixa destino:
          el-input(placeholder="Saidas Esperadas Caixa Destino" type="number" v-model="saidasEsperadasCaixaDestino")
      div.containerDois
        label.cont2 Ação inicial Caixa Destino:
          el-input(placeholder="Digite ação inicial Caixa Destino" type="text" v-model="acaoInicialCaixaDestino")
        label.cont2 Status atuais:
          el-select(placeholder="Selecione os status atuais" v-model="statusAtuais", multiple, collapse-tags, collapse-tags-tooltip, filterable)
            el-option(v-for="s in status" :key="s.codigo" :label="s.nome" :value="s.codigo")
      div.container
        label Perfil:
          el-input.input(placeholder="Perfil" type="text" v-model="perfil")
        label Setor:
          el-input.input(placeholder="Setor" v-model="setor")
        label Ação Destino:
          el-input.input(placeholder="Digite a ação Destino" type="text" v-model="acaoDestino")
      div.botaoContainer
        el-button(@click="mover") mover
</template>
<script>
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { buscarStatus } from '@/utils/manutencao'
import { moverRemessa } from '../../utils/manutencao'
export default {
  components: {},
  data () {
    return {
      caixaAtual: '',
      caixaDestino: '',
      acaoInicialCaixaDestino: '',
      acaoDestino: '',
      perfil: '',
      setor: '',
      saidasEsperadasCaixaDestino: null,
      statusAtuais: [],
      status: []
    }
  },
  async created () {
    try {
      this.status = await buscarStatus()
    } catch (e) {
      this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar dados')
    }
  },
  mixins: [
    AppNotificacao
  ],

  methods: {
    async mover () {
      try {
        await moverRemessa(this.caixaAtual, this.statusAtuais, this.caixaDestino, this.acaoInicialCaixaDestino, this.acaoDestino, this.perfil, this.setor, this.saidasEsperadasCaixaDestino)
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TIPO_SUCCESS, 'Remessa movida!')
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TIPO_ERROR, 'Erro ao mover remessa!')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .input {
    width: 300px;
  }
  .container {
    display: flex;
    flex-direction: row;
  }
  label {
    display: flex;
    flex-direction: column;
    margin: 5px
  }
  .box-processo {
    min-width: 700px;
    padding-left: 3px;
    padding-right: 3px;
  }
  .containerTodo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
  }
  .containerDois {
    display: flex;
    flex-direction: row;
    width: 930px;
  }
  .cont2{
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/MoverPorRemessa.vue